import EditProfileComponent from '../../components/profile/edit_profile';
import { RootState } from '../../redux/store';
import UpdatePasswordComponent from '../../components/profile/update_password';
import UserProfileComponent from '../../components/profile';
import { useSelector } from 'react-redux';

const UserProfilePage = () => {
    const { flags } = useSelector((state: RootState) => state.app);

    if (flags.isEditing) {
        return <EditProfileComponent />;
    } else if (flags.isUpdatingPassword) {
        return <UpdatePasswordComponent />;
    }
    return <UserProfileComponent />;
};

export default UserProfilePage;